export { HeartFill as default } from './HeartFill';
